/*
SLB GENERATED FILE — DO NOT EDIT
Project: Saam Law BaseStation (SLB)
Build-Version: SLB_V4_133_JEE_CHAT_TRANSACTION_CONSOLE_20260910_01
Output: assets/slb.dcr.js
Source: slb_src/slices/dcr/
Build: slb_build/build_dcr.mjs
Built: 2026-09-19 16:53:59.247Z
Content-SHA256: d605187222eae970ed8b31e4e2a31eac7f54baf847b530367981ab67fba10ad1
Content-SHA256-12: d605187222ea
*/

/* MIGRATED SOURCE
   Original asset: /assets/slb.dcr.js
   Note: This file was copied as-is to bring the module under the slice build pipeline.
   Safe refactor can be done later by splitting into multiple numbered parts.
*/

(function(){
  'use strict';
  if(window.__SLB_DCR_V1__) return;
  window.__SLB_DCR_V1__ = true;

  // -------------------------
  // Helpers
  // -------------------------
  function qs(sel, root){ return (root||document).querySelector(sel); }
  function qsa(sel, root){ return Array.from((root||document).querySelectorAll(sel)); }

  function esc(s){
    return String(s||'')
      .replace(/&/g,'&amp;')
      .replace(/</g,'&lt;')
      .replace(/>/g,'&gt;')
      .replace(/"/g,'&quot;')
      .replace(/\'/g,'&#039;');
  }
  function nl2br(s){ return String(s||'').replace(/\n/g,'<br>'); }
  function sanitizeRichHtml_(html){
    // Minimal, consistent with other modules: strip scripts + event handlers.
    var s = String(html||'');
    s = s.replace(/<\s*script[^>]*>[\s\S]*?<\s*\/\s*script\s*>/gi,'');
    s = s.replace(/\son\w+\s*=\s*"[^"]*"/gi,'');
    s = s.replace(/\son\w+\s*=\s*\'[^\']*\'/gi,'');
    s = s.replace(/\son\w+\s*=\s*[^\s>]+/gi,'');
    return s;
  }

  function injectStyleOnce(id, cssText){
    if(document.getElementById(id)) return;
    var st = document.createElement('style');
    st.id = id;
    st.type = 'text/css';
    st.appendChild(document.createTextNode(cssText));
    document.head.appendChild(st);
  }

  var _toastT;
  function toast(msg){
    try{
      if(window.SLB_APP && typeof window.SLB_APP.toast === 'function') return window.SLB_APP.toast(msg);
    }catch(_e){}
    msg = String(msg||'');
    var el = document.getElementById('slbToast');
    if(!el){
      el = document.createElement('div');
      el.id = 'slbToast';
      el.style.position = 'fixed';
      el.style.left = '50%';
      el.style.bottom = '24px';
      el.style.transform = 'translateX(-50%)';
      el.style.background = 'rgba(15,21,23,.92)';
      el.style.color = '#fff';
      el.style.padding = '10px 14px';
      el.style.borderRadius = '999px';
      el.style.fontWeight = '800';
      el.style.zIndex = '99999';
      el.style.boxShadow = '0 8px 30px rgba(0,0,0,.25)';
      el.style.maxWidth = '92vw';
      el.style.whiteSpace = 'nowrap';
      el.style.overflow = 'hidden';
      el.style.textOverflow = 'ellipsis';
      el.style.opacity = '0';
      el.style.transition = 'opacity .18s ease';
      document.body.appendChild(el);
    }
    el.textContent = msg;
    el.style.opacity = '1';
    clearTimeout(_toastT);
    _toastT = setTimeout(function(){ try{ el.style.opacity='0'; }catch(_e){} }, 1800);
  }

  function getRole(){
    try{
      var S = window.SLB_APP && window.SLB_APP.S;
      var callsign = (S && (S.callsign || (S.role && S.role.callsign))) || (sessionStorage.getItem('tyw_callsign')||'') || '';
      callsign = String(callsign||'').trim().toUpperCase();
      var isAdmin = !!(S && (S.isAdmin || (S.role && S.role.isAdmin))) || (sessionStorage.getItem('tyw_isAdmin')==='1');
      var isModerator = !!(S && (S.isModerator || (S.role && S.role.isModerator))) || (sessionStorage.getItem('tyw_isModerator')==='1');
      return { callsign: callsign, isAdmin: isAdmin, isModerator: isModerator };
    }catch(_e){
      return { callsign:'', isAdmin:false, isModerator:false };
    }
  }

  function getResult(res){
    if(res && typeof res === 'object'){
      if(res.ok === false) throw new Error(res.error || 'Error');
      if(res.result != null) return res.result;
      if(res.ok === true && res.data != null) return res.data;
    }
    return res;
  }

  // Letters module default gods (copied so DCR stays consistent with your letter_god list)
  var DEFAULT_GODS = [
    { cn: '三羅祖師', en: 'Saam Law Jo Si' },
    { cn: '天一祖師', en: 'Tin Yat Jo Si' },
    { cn: '關聖帝君', en: 'Gwan Sing Dai Gwan' },
    { cn: '呂祖', en: 'Lui Jo' },
    { cn: '王靈官', en: 'Wong Ling Gwan' },
    { cn: '南斗星君', en: 'Naam Dau Sing Gwan' },
    { cn: '北斗星君', en: 'Bak Dau Sing Gwan' },
    { cn: '斗姥元君', en: 'Dau Mou Yuen Gwan' },
    { cn: '太歲星君', en: 'Tai Sui Sing Gwan' },
    { cn: '城隍', en: 'Sing Wong' },
    { cn: '土地', en: 'Tou Dei' },
    { cn: '祖先', en: 'Ancestors' }
  ];

  var ICONS = { yin:'●', st:'◐', yang:'○' };
  var CYCLE = { yin:'st', st:'yang', yang:'yin' };

  // Report output mapping
  // ST -> XO
  // YIN -> XX
  // YANG -> OO
  function stateToAnswer_(st){
    st = String(st||'').trim().toLowerCase();
    if(st === 'yin') return 'XX';
    if(st === 'yang') return 'OO';
    return 'XO';
  }

  function setIconState_(btn, st){
    if(!btn) return;
    st = String(st||'').trim();
    if(!ICONS[st]) st = 'st';
    try{ btn.dataset.state = st; }catch(_e){}
    try{ btn.textContent = ICONS[st] || ICONS.st; }catch(_e2){}
  }

  function nowYmdHm(){
    try{
      var d = new Date();
      var pad = function(n){ return String(n).padStart(2,'0'); };
      return d.getFullYear()+'-'+pad(d.getMonth()+1)+'-'+pad(d.getDate())+' '+pad(d.getHours())+':'+pad(d.getMinutes());
    }catch(_e){ return ''; }
  }

  function isBlankRow_(row){
    if(!row) return true;
    var q = qs('.dcrQ', row);
    var note = qs('.dcrNote', row);
    var qv = q ? String(q.value||'').trim() : '';
    var nv = note ? String(note.value||'').trim() : '';
    var touched = row.dataset && row.dataset.touched === '1';
    return (!qv && !nv && !touched);
  }

  function ensureStandbyRow_(rowsHost){
    var rows = qsa('.dcrRow', rowsHost);
    if(!rows.length){
      rowsHost.appendChild(makeRow_(1, 'Q'));
      return;
    }
    var last = rows[rows.length-1];
    if(!isBlankRow_(last)){
      rowsHost.appendChild(makeRow_(rows.length+1, 'Q'));
    }
    // re-number
    qsa('.dcrRow', rowsHost).forEach(function(r, idx){
      var num = qs('.dcrNum', r);
      if(num) num.textContent = String(idx+1);
    });
  }

  function setRowType_(row, type){
    type = (type === 'C') ? 'C' : 'Q';
    row.dataset.type = type;
    var tQ = qs('.dcrTypeBtn[data-type="Q"]', row);
    var tC = qs('.dcrTypeBtn[data-type="C"]', row);
    if(tQ) tQ.classList.toggle('active', type === 'Q');
    if(tC) tC.classList.toggle('active', type === 'C');
    var iconsWrap = qs('.dcrIcons', row);
    if(!iconsWrap) return;
    var want = (type === 'C') ? 1 : 3;
    var curr = qsa('.dcrIconBtn', iconsWrap);
    if(curr.length === want) return;
    // keep first icon state if any
    var keepState = (curr[0] && curr[0].dataset && curr[0].dataset.state) ? curr[0].dataset.state : 'st';
    iconsWrap.innerHTML = '';
    for(var i=0;i<want;i++){
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'dcrIconBtn';
      b.dataset.idx = String(i);
      b.dataset.state = (i===0 ? keepState : 'st');
      b.textContent = ICONS[b.dataset.state] || ICONS.st;
      iconsWrap.appendChild(b);
    }
  }

  function makeRow_(n, type){
    var row = document.createElement('div');
    row.className = 'dcrRow';
    row.dataset.type = (type === 'C') ? 'C' : 'Q';
    row.innerHTML = (
      '<div class="dcrNum">'+esc(n)+'</div>'+
      '<div class="dcrTypeSeg" role="group">'
        +'<button type="button" class="dcrTypeBtn active" data-type="Q">Q</button>'
        +'<button type="button" class="dcrTypeBtn" data-type="C">C</button>'
      +'</div>'+
      '<div class="dcrQWrap">'
        +'<input class="inp dcrQ" type="text" placeholder="Type question..." />'
        +'<div class="dcrNoteRow hidden">'
          +'<input class="inp dcrNote" type="text" placeholder="Note (optional)" />'
        +'</div>'
      +'</div>'+
      '<div class="dcrIcons" aria-label="Cups result"></div>'+
      '<div class="dcrRowBtns">'
        +'<button type="button" class="btn soft mini dcrNoteBtn" title="Note">📝</button>'
        +'<button type="button" class="btn soft mini dcrDelBtn" title="Delete">🗑️</button>'
      +'</div>'
    );

    // init icons based on type
    setRowType_(row, row.dataset.type);
    return row;
  }

  function buildReportHtml_(meta, rowsHost){
    var who = String(meta.who||'').trim();
    var talkingTo = String(meta.talkingTo||'').trim();

    var lines = [];
    function pushLineText(t){ lines.push('<div>'+esc(t)+'</div>'); }
    function pushBlank(){ lines.push('<div style="height:10px"></div>'); }

    pushLineText('Divination Recording');
    pushLineText('Date: '+nowYmdHm());
    if(who) pushLineText('Disciple: '+who);
    if(talkingTo) pushLineText('Talking to: '+talkingTo);
    pushBlank();

    var rows = qsa('.dcrRow', rowsHost);
    var count = 0;
    rows.forEach(function(r){
      if(isBlankRow_(r)) return;
      var type = (r.dataset && r.dataset.type === 'C') ? 'C' : 'Q';
      var q = qs('.dcrQ', r);
      var note = qs('.dcrNote', r);
      var qv = q ? String(q.value||'').trim() : '';
      var nv = note ? String(note.value||'').trim() : '';
      if(!qv) qv = (type === 'C') ? '(confirm)' : '(question)';
      count++;

      // question line
      pushLineText(type + count + ': ' + qv);

      // answer line (bold label only)
      var ans = qsa('.dcrIconBtn', r).map(function(b){
        var st = (b && b.dataset && b.dataset.state) ? b.dataset.state : 'st';
        return stateToAnswer_(st);
      });
      lines.push('<div><b>'+esc(type + count + ' Answer:')+'</b> ' + esc(ans.join(' ')) + '</div>');

      if(nv) pushLineText('Note: ' + nv);
      pushBlank();
    });

    if(!count) pushLineText('(No entries yet)');
    return '<div class="slbDcrReport">' + lines.join('') + '</div>';
  }

  // -------------------------
  // Boot
  // -------------------------
  function bootUser_(){
    var root = document.getElementById('slbDcrPanel');
    if(!root) return false;
    if(root.dataset && root.dataset.slbBooted === '1') return true;

    var role = getRole();
    if(!role || !role.callsign){
      // Wait for SLB session
      root.innerHTML = '<div class="muted" style="margin-top:8px;">Loading…</div>';
      return false;
    }

    injectStyleOnce('slb-dcr-css-v3', [
      '#slbDcrPanel .slbDcrWrap{ display:flex; flex-direction:column; gap:12px; }',
      '#slbDcrPanel details.slbDcrDetails{ border:1px solid rgba(15,21,23,.12); border-radius:16px; overflow:hidden; margin:10px 0; background:#fff; }',
      '#slbDcrPanel summary.slbDcrSummary{ list-style:none; display:flex; align-items:center; justify-content:space-between; gap:10px; cursor:pointer; user-select:none; padding:8px 10px; background: var(--ty-grey-ui, rgba(15,21,23,.10)); font-weight:800; color:#0f1517; border-bottom:1px solid rgba(15,21,23,.12); }',
      '#slbDcrPanel summary.slbDcrSummary::-webkit-details-marker{ display:none; }',
      '#slbDcrPanel .slbDcrBody{ padding:12px; }',
      '#slbDcrPanel .slbDcrMetaBox{ border:1px solid var(--ty-border,#e2e6ea); border-radius:14px; padding:12px; background:#f7f7f7; }',
      '#slbDcrPanel .slbRow{ display:flex; gap:10px; align-items:center; margin:8px 0; flex-wrap:wrap; }',
      '#slbDcrPanel .slbLabel{ width:80px; font-weight:900; color:var(--ty-dark,#0f1517); }',
      '#slbDcrPanel .inp{ width:100%; max-width:520px; padding:8px 10px; border-radius:12px; border:1px solid var(--ty-border,#e2e6ea); background:#fff; font-weight:700; }',
      '#slbDcrPanel .inp:focus{ outline:none; box-shadow:0 0 0 4px rgba(239,94,20,.18); border-color: rgba(239,94,20,.45); }',
      '#slbDcrPanel .seg{ display:flex; border:1px solid var(--ty-border,#e2e6ea); border-radius:999px; overflow:hidden; background:#fff; }',
      '#slbDcrPanel .segBtn{ flex:1; padding:8px 10px; border:0; background:transparent; cursor:pointer; font-weight:900; color:var(--ty-dark,#0f1517); }',
      '#slbDcrPanel .segBtn.active{ background: rgba(15,21,23,.08); }',
      '#slbDcrPanel .segBtn:focus{ outline:none; box-shadow:0 0 0 4px rgba(239,94,20,.18); }',
      '#slbDcrPanel .btn{ display:inline-flex; align-items:center; justify-content:center; gap:8px; padding:10px 14px; border-radius:999px; border:1px solid rgba(15,21,23,.18); background:#fff; cursor:pointer; font-weight:900; color:var(--ty-dark,#0f1517); }',
      '#slbDcrPanel .btn:disabled{ opacity:.55; cursor:not-allowed; }',
      '#slbDcrPanel .btn.soft{ background:#fff; }',
      '#slbDcrPanel .btn.primary{ background: var(--ty-orange,#ef5e14); border-color: var(--ty-orange,#ef5e14); color:#fff; }',
      '#slbDcrPanel .btn.email{ background:#b00020; border-color:#b00020; color:#fff; }',
      '#slbDcrPanel #slbDcrConfirm, #slbDcrPanel #slbDcrFinalize, #slbDcrPanel #slbDcrSave{ background:var(--slb-action-orange-bg,var(--ty-orange,#ef5e14)) !important; border-color:var(--slb-action-orange-border,var(--ty-orange,#ef5e14)) !important; color:#fff !important; box-shadow:var(--slb-action-orange-shadow,none) !important; }',
      '#slbDcrPanel #slbDcrVEdit{ background:var(--slb-action-orange-bg,var(--ty-orange,#ef5e14)) !important; border-color:var(--slb-action-orange-border,var(--ty-orange,#ef5e14)) !important; color:#fff !important; box-shadow:var(--slb-action-orange-shadow,none) !important; }',
      '#slbDcrPanel #slbDcrEmailJee{ background:#b00020 !important; border-color:#b00020 !important; color:#fff !important; }',

      '#slbDcrPanel .muted{ color: #6b7280; }',
      '#slbDcrPanel .muted.small{ font-size:12px; }',

      '#slbDcrPanel .dcrLocked{ display:flex; gap:10px; align-items:center; flex-wrap:wrap; padding:8px 10px; border-radius:12px; background: rgba(239,94,20,.08); border:1px solid rgba(239,94,20,.35); font-weight:900; }',
      '#slbDcrPanel .dcrLocked .tag{ background:#fff; border:1px solid rgba(15,21,23,.12); border-radius:999px; padding:6px 10px; font-weight:900; }',

      '#slbDcrPanel .dcrRows{ display:flex; flex-direction:column; gap:8px; }',
      '#slbDcrPanel .dcrRow{ display:grid; grid-template-columns: 42px 84px 1fr 160px 110px; gap:8px; align-items:start; padding:8px; border:1px solid rgba(15,21,23,.10); border-radius:14px; background:#fff; }',
      '#slbDcrPanel .dcrRows .dcrRow:nth-child(odd){ background: var(--ty-surface-2,#fff3e6); }',
      '#slbDcrPanel .dcrRows .dcrRow:nth-child(even){ background: var(--ty-surface-3,#fff); }',
      '@media (max-width: 840px){ #slbDcrPanel .dcrRow{ grid-template-columns: 42px 84px 1fr; } #slbDcrPanel .dcrIcons{ grid-column: 1 / -1; } #slbDcrPanel .dcrRowBtns{ grid-column: 1 / -1; justify-content:flex-end; } }',
      '#slbDcrPanel .dcrNum{ font-weight:1000; text-align:center; padding-top:8px; }',

      '#slbDcrPanel .dcrTypeSeg{ display:flex; border:1px solid var(--ty-border,#e2e6ea); border-radius:999px; overflow:hidden; background:#fff; }',
      '#slbDcrPanel .dcrTypeBtn{ flex:1; border:0; background:#fff; cursor:pointer; padding:8px 10px; font-weight:1000; color: rgba(239,94,20,.78); }',
      '#slbDcrPanel .dcrTypeBtn.active{ background: var(--ty-orange,#ef5e14); color:#fff; }',
      '#slbDcrPanel .dcrTypeBtn:hover{ background: rgba(239,94,20,.08); }',

      '#slbDcrPanel .dcrQWrap{ display:flex; flex-direction:column; gap:8px; }',
      '#slbDcrPanel .dcrNoteRow{ display:flex; gap:8px; }',
      '#slbDcrPanel .hidden{ display:none !important; }',

      '#slbDcrPanel .dcrIcons{ display:flex; gap:10px; align-items:center; justify-content:flex-start; flex-wrap:wrap; padding-top:6px; }',
      '#slbDcrPanel .dcrIconBtn{ width:44px; height:44px; border-radius:999px; border:2px solid rgba(15,21,23,.22); background:#fff; cursor:pointer; font-weight:1000; font-size:22px; line-height:1; color:var(--ty-dark,#0f1517); }',
      '#slbDcrPanel .dcrIconBtn:hover{ border-color: rgba(239,94,20,.55); box-shadow: 0 8px 20px rgba(239,94,20,.15); }',
      '#slbDcrPanel .dcrIconBtn[data-state="yin"], #slbDcrPanel .dcrIconBtn[data-state="yang"]{ font-size:34px; }',
      '#slbDcrPanel .dcrIconBtn[data-state="st"]{ font-size:22px; }',
      '#slbDcrPanel .dcrRowBtns{ display:flex; gap:8px; justify-content:flex-end; align-items:center; }',

      '#slbDcrPanel .slbDcrGrid{ display:grid; grid-template-columns: 380px 1fr; gap:12px; align-items:start; }',
      '@media (max-width: 900px){ #slbDcrPanel .slbDcrGrid{ grid-template-columns: 1fr; } }',
      '#slbDcrPanel .slbDcrList{ border:1px solid rgba(15,21,23,.12); border-radius:14px; overflow:hidden; background:#fff; }',
      '#slbDcrPanel .slbDcrListHead{ padding:8px 10px; background: var(--ty-grey-ui, rgba(15,21,23,.10)); font-weight:1000; color:#0f1517; border-bottom:1px solid rgba(15,21,23,.12); }',
      '#slbDcrPanel .slbDcrItem{ display:block; width:100%; text-align:left; padding:10px 10px; border:0; border-bottom:1px solid rgba(15,21,23,.08); background:transparent; cursor:pointer; color:#0f1517; }',
      '#slbDcrPanel .slbDcrItem:last-child{ border-bottom:0; }',
      '#slbDcrPanel .slbDcrList .slbDcrItem:nth-of-type(odd){ background: var(--ty-surface-2,#fff3e6); }',
      '#slbDcrPanel .slbDcrList .slbDcrItem:nth-of-type(even){ background: var(--ty-surface-3,#fff); }',
      '#slbDcrPanel .slbDcrItem:hover{ background: var(--ty-hover,#ffe5d1); }',
      '#slbDcrPanel .slbDcrItem.active{ background: var(--ty-active,#ffd4b4); }',
      '#slbDcrPanel .slbDcrItem:focus{ outline:none; }',
      '#slbDcrPanel .slbDcrItemTop{ display:flex; align-items:center; justify-content:space-between; gap:10px; }',
      '#slbDcrPanel .slbDcrItemDate{ font-weight:1000; color:#0f1517; }',
      '#slbDcrPanel .slbDcrItemAge{ font-size:12px; color: var(--ty-muted,#6b7680); font-weight:900; }',
      '#slbDcrPanel .slbDcrItemSnip{ margin-top:4px; font-size:12px; color: var(--ty-muted,#6b7680); }',
      '#slbDcrPanel .slbDcrItemTag{ margin-top:4px; font-size:12px; color: var(--ty-muted,#6b7680); }',

      '#slbDcrPanel .slbDcrViewer{ border:1px solid rgba(15,21,23,.12); border-radius:14px; overflow:hidden; background:#fff; min-height:180px; }',
      '#slbDcrPanel .slbDcrViewerHead{ display:flex; align-items:center; justify-content:space-between; gap:10px; padding:8px 10px; background: var(--ty-grey-ui, rgba(15,21,23,.10)); border-bottom:1px solid rgba(15,21,23,.12); }',
      '#slbDcrPanel .slbDcrViewerTitle{ font-weight:1000; color:#0f1517; }',
      '#slbDcrPanel .slbDcrViewerBtns{ display:flex; gap:8px; align-items:center; flex-wrap:wrap; }',
      '#slbDcrPanel .slbDcrViewerBtns .btn{ border-radius:12px; padding:8px 10px; font-weight:1000; font-size:13px; }',
      '#slbDcrPanel .slbDcrViewerBtns .btn.icon{ width:38px; height:36px; padding:0; border-radius:12px; }',
      '#slbDcrPanel .slbDcrViewerBtns .btn.icon.edit{ color: var(--ty-orange,#ef5e14); }',
      '#slbDcrPanel .slbDcrViewerBtns .btn.danger{ background:#b00020; border-color:#b00020; color:#fff; }',
      '#slbDcrPanel .slbDcrViewerBody{ padding:12px; }',
      '#slbDcrPanel .slbDcrCard{ border:1px solid rgba(15,21,23,.12); border-radius:12px; padding:8px 10px; background:#fff; }',
      '#slbDcrPanel .slbDcrCard h4{ margin:0 0 8px 0; font-size:13px; letter-spacing:.2px; }',
      '#slbDcrPanel .slbDcrMetaLine{ font-size:12px; color: var(--ty-muted,#6b7680); display:flex; gap:10px; flex-wrap:wrap; }',
      '#slbDcrPanel .slbStdEditorWrap{ }',
      '#slbDcrPanel .richEditor{ }'
    ].join('\n'));

    root.dataset.slbBooted = '1';

    // Render
    root.innerHTML = [
      '<div class="slbDcrWrap">',

      '<details class="slbDcrDetails" open>',
        '<summary class="slbDcrSummary"><div>Divination Recording</div><div></div></summary>',
        '<div class="slbDcrBody">',
          '<div class="slbDcrMetaBox" id="slbDcrMetaBox">',
            '<div class="slbRow">',
              '<div class="slbLabel">For</div>',
              '<div class="seg" id="slbDcrWhoSeg">',
                '<button type="button" class="segBtn active" data-who="me">For Myself</button>',
                '<button type="button" class="segBtn" data-who="other">For Others</button>',
              '</div>',
            '</div>',
            '<div class="slbRow" id="slbDcrNameRow">',
              '<div class="slbLabel">Name</div>',
              '<input class="inp" id="slbDcrName" type="text" placeholder="Enter name" />',
            '</div>',
            '<div class="slbRow">',
              '<div class="slbLabel">God</div>',
              '<div style="flex:1;min-width:240px;max-width:520px;">',
                '<select class="inp" id="slbDcrGodSel"></select>',
                '<input class="inp hidden" id="slbDcrGodCustom" type="text" placeholder="Type god name" style="margin-top:8px;" />',
              '</div>',
            '</div>',
            '<div class="slbRow">',
              '<div class="slbLabel"></div>',
              '<button type="button" class="btn primary" id="slbDcrConfirm">Confirm</button>',
              '<button type="button" class="btn" id="slbDcrUnlock" style="display:none;">Change</button>',
            '</div>',
            '<div class="slbRow" id="slbDcrLockedLine" style="display:none;">',
              '<div class="slbLabel"></div>',
              '<div class="dcrLocked">',
                '<span class="tag" id="slbDcrLockedWho"></span>',
                '<span style="opacity:.75;">→</span>',
                '<span class="tag" id="slbDcrLockedGod"></span>',
                '<span class="muted small" style="margin-left:auto;">Locked</span>',
              '</div>',
            '</div>',
          '</div>',

          '<div style="height:10px;"></div>',

          '<div id="slbDcrSession" style="display:none;">',
            '<div class="muted small" style="margin:0 0 8px 0;">Q = Question (3 cups). C = Confirm (1 cup). Click circles to cycle Yin / ST / Yang.</div>',
            '<div class="dcrRows" id="slbDcrRows"></div>',
            '<div class="slbRow" style="justify-content:center;margin-top:12px;">',
              '<button type="button" class="btn" id="slbDcrClear">Clear</button>',
              '<button type="button" class="btn primary" id="slbDcrFinalize">Finalize</button>',
            '</div>',
          '</div>',

        '</div>',
      '</details>',

      '<details class="slbDcrDetails" open>',
        '<summary class="slbDcrSummary"><div>Final Output</div><div></div></summary>',
        '<div class="slbDcrBody">',
          '<div class="slbRow">',
            '<div class="slbLabel">Tag</div>',
            '<input class="inp" type="text" id="slbDcrTag" placeholder="A few words that describe the topic of your div session" />',
          '</div>',
          '<div class="slbStdEditor" data-slbeditor="v1" id="slbDcrStdEditor" data-slbeditor-height="360">',
            '<div class="slbWysToolbar slbStdToolbar">',
              '<div class="slbWysRow">',
                '<div class="slbWysGroup">',
                  '<select class="inp" data-wys-heading style="width:160px;">',
                    '<option value="p">Paragraph</option>',
                    '<option value="h1">H1</option>',
                    '<option value="h2">H2</option>',
                    '<option value="h3">H3</option>',
                    '<option value="h4">H4</option>',
                  '</select>',
                  '<select class="inp" data-wys-size style="width:110px;">',
                    '<option value="12">12</option>',
                    '<option value="14" selected>14</option>',
                    '<option value="16">16</option>',
                    '<option value="18">18</option>',
                    '<option value="20">20</option>',
                    '<option value="24">24</option>',
                    '<option value="28">28</option>',
                    '<option value="32">32</option>',
                    '<option value="40">40</option>',
                  '</select>',
                '</div>',

                '<div class="slbWysGroup">',
                  '<button class="btn soft mini" type="button" data-wcmd="bold"><b>B</b></button>',
                  '<button class="btn soft mini" type="button" data-wcmd="italic"><i>I</i></button>',
                  '<button class="btn soft mini" type="button" data-wcmd="underline"><u>U</u></button>',
                  '<button class="btn soft mini" type="button" data-wcmd="strikeThrough"><s>S</s></button>',
                '</div>',

                '<div class="slbWysGroup">',
                  '<button class="btn soft mini" type="button" data-wcmd="insertUnorderedList" title="Bullet list">•</button>',
                  '<button class="btn soft mini" type="button" data-wcmd="insertOrderedList" title="Number list">1.</button>',
                  '<button class="btn soft mini" type="button" data-wcmd="justifyLeft" title="Align left">⟸</button>',
                  '<button class="btn soft mini" type="button" data-wcmd="justifyCenter" title="Align center">⇔</button>',
                  '<button class="btn soft mini" type="button" data-wcmd="justifyRight" title="Align right">⟹</button>',
                  '<button class="btn soft mini" type="button" data-wcmd="justifyFull" title="Justify">☰</button>',
                  '<button class="btn soft mini" type="button" data-wcmd="quote" title="Quote">❝</button>',
                '</div>',
              '</div>',

              '<div class="slbWysRow">',
                '<div class="slbWysGroup">',
                  '<button class="btn square mini" type="button" data-wcolor="#ef4444" style="background:#ef4444;color:#fff;">A</button>',
                  '<button class="btn square mini" type="button" data-wcolor="#f59e0b" style="background:#f59e0b;color:#fff;">A</button>',
                  '<button class="btn square mini" type="button" data-wcolor="#10b981" style="background:#10b981;color:#fff;">A</button>',
                  '<button class="btn square mini" type="button" data-wcolor="#3b82f6" style="background:#3b82f6;color:#fff;">A</button>',
                  '<button class="btn square mini" type="button" data-wcolor="#7c3aed" style="background:#7c3aed;color:#fff;">A</button>',
                  '<input type="color" class="inp" data-wys-colorpicker style="width:36px;padding:0;" />',
                '</div>',

                '<div class="slbWysGroup">',
                  '<button class="btn square mini" type="button" data-wbg="#fde68a" style="background:#fde68a;color:#000;">HL</button>',
                  '<button class="btn square mini" type="button" data-wbg="#bbf7d0" style="background:#bbf7d0;color:#000;">HL</button>',
                  '<button class="btn square mini" type="button" data-wbg="#bfdbfe" style="background:#bfdbfe;color:#000;">HL</button>',
                  '<button class="btn square mini" type="button" data-wbg="#fecaca" style="background:#fecaca;color:#000;">HL</button>',
                  '<button class="btn square mini" type="button" data-wbg="#f3e8ff" style="background:#f3e8ff;color:#000;">HL</button>',
                  '<input type="color" class="inp" data-wys-hlpicker style="width:36px;padding:0;" />',
                '</div>',

                '<div class="slbWysGroup slbEmojiWrap">',
                  '<button class="btn soft mini" type="button" data-wcmd="emoji" title="Emojis">🙂</button>',
                  '<div class="slbEmojiPanel hidden">',
                    '<button class="slbEmojiItem" type="button" data-emoji="😀">😀</button>',
                    '<button class="slbEmojiItem" type="button" data-emoji="😁">😁</button>',
                    '<button class="slbEmojiItem" type="button" data-emoji="😄">😄</button>',
                    '<button class="slbEmojiItem" type="button" data-emoji="😂">😂</button>',
                    '<button class="slbEmojiItem" type="button" data-emoji="🤣">🤣</button>',
                    '<button class="slbEmojiItem" type="button" data-emoji="🙂">🙂</button>',
                    '<button class="slbEmojiItem" type="button" data-emoji="😉">😉</button>',
                    '<button class="slbEmojiItem" type="button" data-emoji="😎">😎</button>',
                    '<button class="slbEmojiItem" type="button" data-emoji="🤔">🤔</button>',
                    '<button class="slbEmojiItem" type="button" data-emoji="😮">😮</button>',
                    '<button class="slbEmojiItem" type="button" data-emoji="😭">😭</button>',
                    '<button class="slbEmojiItem" type="button" data-emoji="😡">😡</button>',
                    '<button class="slbEmojiItem" type="button" data-emoji="👍">👍</button>',
                    '<button class="slbEmojiItem" type="button" data-emoji="👎">👎</button>',
                    '<button class="slbEmojiItem" type="button" data-emoji="🙏">🙏</button>',
                    '<button class="slbEmojiItem" type="button" data-emoji="✨">✨</button>',
                    '<button class="slbEmojiItem" type="button" data-emoji="⚡">⚡</button>',
                    '<button class="slbEmojiItem" type="button" data-emoji="❤️">❤️</button>',
                    '<button class="slbEmojiItem" type="button" data-emoji="💜">💜</button>',
                    '<button class="slbEmojiItem" type="button" data-emoji="🔥">🔥</button>',
                    '<button class="slbEmojiItem" type="button" data-emoji="🌙">🌙</button>',
                    '<button class="slbEmojiItem" type="button" data-emoji="⭐">⭐</button>',
                    '<button class="slbEmojiItem" type="button" data-emoji="✅">✅</button>',
                    '<button class="slbEmojiItem" type="button" data-emoji="❗">❗</button>',
                    '<button class="slbEmojiItem" type="button" data-emoji="💡">💡</button>',
                    '<button class="slbEmojiItem" type="button" data-emoji="📌">📌</button>',
                    '<button class="slbEmojiItem" type="button" data-emoji="🧧">🧧</button>',
                    '<button class="slbEmojiItem" type="button" data-emoji="🐉">🐉</button>',
                    '<button class="slbEmojiItem" type="button" data-emoji="☯️">☯️</button>',
                    '<button class="slbEmojiItem" type="button" data-emoji="🌀">🌀</button>',
                    '<button class="slbEmojiItem" type="button" data-emoji="🛡️">🛡️</button>',
                    '<button class="slbEmojiItem" type="button" data-emoji="🎯">🎯</button>',
                    '<button class="slbEmojiItem" type="button" data-emoji="📣">📣</button>',
                    '<button class="slbEmojiItem" type="button" data-emoji="🤝">🤝</button>',
                    '<button class="slbEmojiItem" type="button" data-emoji="🟠">🟠</button>',
                    '<button class="slbEmojiItem" type="button" data-emoji="⚔️">⚔️</button>',
                  '</div>',
                '</div>',

                '<div class="slbWysGroup slbWysEnd">',
                  '<button class="btn soft mini" type="button" data-wcmd="createLink" title="Link">🔗</button>',
                  '<button class="btn soft mini" type="button" data-wcmd="insertImage" title="Image">🖼️</button>',
                  '<button class="btn soft mini" type="button" data-wcmd="yt" title="YouTube">▶️</button>',
                  '<button class="btn soft mini square" type="button" data-wcmd="removeFormat" title="Clear formatting">✕</button>',
                '</div>',
              '</div>',
            '</div>',

            '<div class="richEditor slbStdArea" data-slbeditor-area contenteditable="true" spellcheck="true" id="slbDcrFinalRich"></div>',

          '</div>',

          '<div class="slbRow" style="justify-content:center;margin-top:12px;">',
            '<button type="button" class="btn primary" id="slbDcrSave" disabled>SAVE</button>',
            '<button type="button" class="btn email" id="slbDcrEmailJee" disabled>&gt;&gt; Si Juen</button>',
          '</div>',

        '</div>',
      '</details>',

            '<details class="slbDcrDetails" open>',
        '<summary class="slbDcrSummary"><div>Records</div><div></div></summary>',
        '<div class="slbDcrBody">',

          '<div class="slbRow" style="gap:8px; flex-wrap:wrap;">',
            '<input class="slbInput" id="slbDcrSearch" placeholder="Search (date / name / god)..." style="flex:1; min-width:220px;">',
          '</div>',

          '<div class="slbDcrGrid" style="margin-top:10px;">',
            '<div id="slbDcrList" class="slbDcrList"></div>',
            '<div id="slbDcrViewer" class="slbDcrViewer"></div>',
          '</div>',

        '</div>',
      '</details>',

      '</div>'
    ].join('');

    // Fill defaults
    var whoSeg = qs('#slbDcrWhoSeg', root);
    var nameInp = qs('#slbDcrName', root);
    var godSel = qs('#slbDcrGodSel', root);
    var godCustom = qs('#slbDcrGodCustom', root);
    var bConfirm = qs('#slbDcrConfirm', root);
    var bUnlock = qs('#slbDcrUnlock', root);
    var lockedLine = qs('#slbDcrLockedLine', root);
    var lockedWho = qs('#slbDcrLockedWho', root);
    var lockedGod = qs('#slbDcrLockedGod', root);
    var session = qs('#slbDcrSession', root);
    var rowsHost = qs('#slbDcrRows', root);
    var bClear = qs('#slbDcrClear', root);
    var bFinalize = qs('#slbDcrFinalize', root);
    var finalRich = qs('#slbDcrFinalRich', root);
    var tagInp = qs('#slbDcrTag', root);
    var edRoot = qs('#slbDcrStdEditor', root);
    var bSave = qs('#slbDcrSave', root);
    var bEmailJee = qs('#slbDcrEmailJee', root);

    try{ if(edRoot && window.SLB_STD_EDITOR_V1 && window.SLB_STD_EDITOR_V1.bind) window.SLB_STD_EDITOR_V1.bind(edRoot); }catch(_e){}

    function setWho_(who){
      who = (who === 'other') ? 'other' : 'me';
      qsa('.segBtn', whoSeg).forEach(function(b){ b.classList.toggle('active', (b.dataset && b.dataset.who) === who); });
      if(who === 'me'){
        nameInp.value = String(role.callsign||'');
        nameInp.disabled = true;
      }else{
        nameInp.disabled = false;
        if(String(nameInp.value||'').trim() === String(role.callsign||'').trim()) nameInp.value = '';
        nameInp.focus();
      }
    }

function fillGodSelLoading_(){
  if(!godSel) return;
  var opts = [];
  opts.push('<option value="" disabled selected>Loading gods…</option>');
  opts.push('<option value="__custom__">Custom...</option>');
  godSel.innerHTML = opts.join('');
}

function fillGodSelFromItems_(items){
  if(!godSel) return;
  var opts = [];
  opts.push('<option value="" disabled selected>Pick a God...</option>');
  (items||[]).forEach(function(it){
    var label = String((it && it.name) || '').trim();
    if(!label){
      var cn = String((it && it.cn) || '').trim();
      var en = String((it && it.en) || '').trim();
      if(cn && en) label = cn + ' (' + en + ')';
      else label = cn || en || '';
    }
    if(!label) return;
    opts.push('<option value="'+esc(label)+'">'+esc(label)+'</option>');
  });
  opts.push('<option value="__custom__">Custom...</option>');
  godSel.innerHTML = opts.join('');
}

function fillGodSelError_(){
  if(!godSel) return;
  var opts = [];
  opts.push('<option value="" disabled selected>God list not found. Check LETTER_GOD.</option>');
  opts.push('<option value="__custom__">Custom...</option>');
  godSel.innerHTML = opts.join('');
}

function loadGodSelFromSheet_(_tries){
  _tries = _tries || 0;
  var rpcFn = (window.SLB_APP && typeof window.SLB_APP.rpc === 'function') ? window.SLB_APP.rpc.bind(window.SLB_APP) : null;
  if(!rpcFn){
    if(_tries < 40) return setTimeout(function(){ loadGodSelFromSheet_(_tries+1); }, 250);
    fillGodSelError_();
    return;
  }
  rpcFn('letterGodsList', {}).then(function(res){
    var r = getResult(res) || {};
    var items = r.items || [];
    fillGodSelFromItems_(items);
  }).catch(function(e){
    console.error(e);
    fillGodSelError_();
  });
}


    function getTalkingTo_(){
      var v = String(godSel && godSel.value ? godSel.value : '').trim();
      if(v === '__custom__') v = String(godCustom && godCustom.value ? godCustom.value : '').trim();
      return v;
    }

    function setGodUi_(godName){
      godName = String(godName||'').trim();
      if(!godSel){
        if(godCustom){
          if(godName){ godCustom.value = godName; godCustom.classList.remove('hidden'); }
          else{ godCustom.value = ''; godCustom.classList.add('hidden'); }
        }
        return;
      }

      if(!godName){
        try{ godSel.value = ''; }catch(_e){}
        if(godCustom){ godCustom.value = ''; godCustom.classList.add('hidden'); }
        return;
      }

      var found = false;
      try{
        var opts = godSel.options || [];
        for(var i=0;i<opts.length;i++){
          if(String(opts[i].value||'').trim() === godName){ found = true; break; }
        }
      }catch(_e2){ found = false; }

      if(found){
        try{ godSel.value = godName; }catch(_e3){}
        if(godCustom){ godCustom.value = ''; godCustom.classList.add('hidden'); }
      }else{
        try{ godSel.value = '__custom__'; }catch(_e4){}
        if(godCustom){ godCustom.classList.remove('hidden'); godCustom.value = godName; }
      }
    }

    function setMetaUi_(it){
      it = it || {};
      var fm = String(it.forMode || '').trim().toLowerCase();
      var who = (fm.indexOf('other') === 0 || fm === 'others') ? 'other' : 'me';

      try{ unlock_(); }catch(_e){}
      setWho_(who);
      if(who === 'other' && nameInp){
        nameInp.value = String(it.targetName || '').trim();
      }
      setGodUi_(it.godName || '');
      try{ lock_(); }catch(_e2){}
    }

    function lock_(){
      var whoTxt = String(nameInp.value||'').trim();
      var godTxt = getTalkingTo_();
      if(!whoTxt){ toast('Enter name first.'); return false; }
      if(!godTxt){ toast('Pick a God first.'); return false; }

      // lock UI
      qsa('.segBtn', whoSeg).forEach(function(b){ b.disabled = true; });
      nameInp.disabled = true;
      godSel.disabled = true;
      if(godCustom) godCustom.disabled = true;
      if(bConfirm) bConfirm.style.display = 'none';
      if(bUnlock) bUnlock.style.display = '';

      if(lockedLine) lockedLine.style.display = '';
      if(lockedWho) lockedWho.textContent = whoTxt;
      if(lockedGod) lockedGod.textContent = godTxt;

      if(session) session.style.display = '';
      if(rowsHost){
        rowsHost.innerHTML = '';
        rowsHost.appendChild(makeRow_(1,'Q'));
        ensureStandbyRow_(rowsHost);
      }

      toast('Confirmed.');
      return true;
    }

    function unlock_(){
      qsa('.segBtn', whoSeg).forEach(function(b){ b.disabled = false; });
      godSel.disabled = false;
      if(godCustom) godCustom.disabled = false;
      if(bConfirm) bConfirm.style.display = '';
      if(bUnlock) bUnlock.style.display = 'none';
      if(lockedLine) lockedLine.style.display = 'none';
      if(session) session.style.display = 'none';
      if(rowsHost) rowsHost.innerHTML = '';
    }

    function resetAll_(){
      unlock_();
      setWho_('me');
      if(godSel){ godSel.value = ''; }
      if(godCustom){ godCustom.value = ''; godCustom.classList.add('hidden'); }
      if(tagInp){ tagInp.value = ''; }
      if(finalRich) finalRich.innerHTML = '';
      if(bSave) bSave.disabled = true;
      if(bEmailJee) bEmailJee.disabled = true;
    }

    // init
    fillGodSelLoading_();
    loadGodSelFromSheet_();
    setWho_('me');

    // interactions
    if(whoSeg){
      whoSeg.addEventListener('click', function(ev){
        var btn = ev.target && ev.target.closest ? ev.target.closest('.segBtn') : null;
        if(!btn || btn.disabled) return;
        ev.preventDefault();
        ev.stopPropagation();
        setWho_(btn.dataset && btn.dataset.who);
      });
    }

    if(godSel){
      godSel.addEventListener('change', function(){
        if(String(godSel.value||'') === '__custom__'){
          godCustom.classList.remove('hidden');
          godCustom.focus();
        }else{
          godCustom.classList.add('hidden');
          godCustom.value = '';
        }
      });
    }

    if(bConfirm) bConfirm.addEventListener('click', function(){ lock_(); });
    if(bUnlock) bUnlock.addEventListener('click', function(){ unlock_(); });

    // row-level events (delegate)
    if(rowsHost){
      rowsHost.addEventListener('click', function(ev){
        var icon = ev.target && ev.target.closest ? ev.target.closest('.dcrIconBtn') : null;
        if(icon){
          ev.preventDefault();
          var st = icon.dataset && icon.dataset.state ? icon.dataset.state : 'st';
          st = CYCLE[st] || 'st';
          icon.dataset.state = st;
          icon.textContent = ICONS[st] || ICONS.st;
          var row = ev.target.closest('.dcrRow');
          if(row){ row.dataset.touched = '1'; }
          ensureStandbyRow_(rowsHost);
          return;
        }

        var tBtn = ev.target && ev.target.closest ? ev.target.closest('.dcrTypeBtn') : null;
        if(tBtn){
          ev.preventDefault();
          var row2 = tBtn.closest('.dcrRow');
          if(row2){
            setRowType_(row2, tBtn.dataset && tBtn.dataset.type);
            var q = qs('.dcrQ', row2);
            if(q) q.placeholder = (row2.dataset.type === 'C') ? 'Type confirm...' : 'Type question...';
            ensureStandbyRow_(rowsHost);
          }
          return;
        }

        var noteBtn = ev.target && ev.target.closest ? ev.target.closest('.dcrNoteBtn') : null;
        if(noteBtn){
          ev.preventDefault();
          var row3 = noteBtn.closest('.dcrRow');
          if(row3){
            var nr = qs('.dcrNoteRow', row3);
            if(nr) nr.classList.toggle('hidden');
            var nt = qs('.dcrNote', row3);
            if(nt && !nr.classList.contains('hidden')) nt.focus();
          }
          return;
        }

        var delBtn = ev.target && ev.target.closest ? ev.target.closest('.dcrDelBtn') : null;
        if(delBtn){
          ev.preventDefault();
          var row4 = delBtn.closest('.dcrRow');
          if(row4){
            row4.remove();
            ensureStandbyRow_(rowsHost);
          }
          return;
        }
      });

      rowsHost.addEventListener('input', function(ev){
        var row = ev.target && ev.target.closest ? ev.target.closest('.dcrRow') : null;
        if(row){ row.dataset.touched = '1'; }
        ensureStandbyRow_(rowsHost);
      });
    }

    if(bClear){
      bClear.addEventListener('click', function(){
        resetAll_();
        toast('Cleared.');
      });
    }

    if(bFinalize){
      bFinalize.addEventListener('click', function(){
        bFinalize.disabled = true;
        try{
          var meta = {
            who: String(nameInp.value||'').trim(),
            talkingTo: getTalkingTo_()
          };
          var repHtml = buildReportHtml_(meta, rowsHost);
          if(finalRich){
            finalRich.innerHTML = sanitizeRichHtml_(String(repHtml||''));
          }
          if(bSave) bSave.disabled = false;
          if(bEmailJee) bEmailJee.disabled = false;
          toast('Finalized.');
        }catch(_e){
          toast('Could not finalize.');
        }finally{
          bFinalize.disabled = false;
        }
      });
    }

    // ===== Phase 2: Save / Records / Email (Backend RPC) =====
    function getRpc_(){
      return (window.SLB_APP && typeof window.SLB_APP.rpc === 'function') ? window.SLB_APP.rpc.bind(window.SLB_APP) : null;
    }

    async function rpcData_(action, args){
      var rpcFn = getRpc_();
      if(!rpcFn) throw new Error('Backend not ready.');
      var res = await rpcFn(action, args||{});
      return getResult(res) || {};
    }

    function dateKeyNow_(){
      try{
        return new Intl.DateTimeFormat('en-CA', {timeZone:'America/Toronto', year:'numeric', month:'2-digit', day:'2-digit'}).format(new Date());
      }catch(_e){
        var d = new Date();
        var mm = String(d.getMonth()+1).padStart(2,'0');
        var dd = String(d.getDate()).padStart(2,'0');
        return d.getFullYear() + '-' + mm + '-' + dd;
      }
    }

    function toDate_(s){ try{ var d=new Date(s); if(!d||isNaN(d.getTime())) return null; return d; }catch(_e){ return null; } }
    function fmtYmd_(d){
      if(!d) return '';
      try{
        return new Intl.DateTimeFormat('en-CA', {timeZone:'America/Toronto', year:'numeric', month:'2-digit', day:'2-digit'}).format(d);
      }catch(_e){
        var mm = String(d.getMonth()+1).padStart(2,'0');
        var dd = String(d.getDate()).padStart(2,'0');
        return d.getFullYear() + '-' + mm + '-' + dd;
      }
    }
    function fmtDateKey_(dk){
      dk = String(dk||'').trim();
      if(!dk) return '';
      if(/^\d{4}-\d{2}-\d{2}$/.test(dk)) return dk;
      var d = toDate_(dk);
      if(d) return fmtYmd_(d);
      var m = dk.match(/(\d{4}-\d{2}-\d{2})/);
      if(m) return m[1];
      return dk.length>10 ? dk.slice(0,10) : dk;
    }

    function timeAgo_(iso){
      var t = Date.parse(String(iso||''));
      if(!t || !isFinite(t)) return '';
      var s = Math.floor((Date.now() - t)/1000);
      if(s < 0) s = 0;
      if(s < 60) return s + 's';
      var m = Math.floor(s/60);
      if(m < 60) return m + 'm';
      var h = Math.floor(m/60);
      if(h < 24) return h + 'h';
      var d = Math.floor(h/24);
      if(d < 30) return d + 'd';
      var mo = Math.floor(d/30);
      if(mo < 12) return mo + 'mo';
      var y = Math.floor(mo/12);
      return y + 'y';
    }

    function getForMode_(){
      var active = whoSeg ? qs('.segBtn.active', whoSeg) : null;
      var w = (active && active.dataset) ? active.dataset.who : 'me';
      return (w === 'other') ? 'others' : 'myself';
    }

    function getTargetName_(){
      var mode = getForMode_();
      if(mode === 'myself') return String((role && role.callsign) || (nameInp && nameInp.value) || '').trim();
      return String((nameInp && nameInp.value) || '').trim();
    }

    function getGodName_(){
      return getTalkingTo_();
    }

    function collectRowsState_(){
      var rows = [];
      qsa('.dcrRow', rowsHost).forEach(function(row){
        var qInp = qs('.dcrQ', row);
        var nInp = qs('.dcrNote', row);
        var q = String(qInp ? qInp.value : '').trim();
        var note = String(nInp ? nInp.value : '');
        var type = (row.dataset && row.dataset.type === 'C') ? 'C' : 'Q';
        var iconBtns = qsa('.dcrIconBtn', row);
        var icons = iconBtns.map(function(b){ return String((b.dataset && b.dataset.state) || 'st'); });
        var nr = qs('.dcrNoteRow', row);
        var noteOpen = nr ? !nr.classList.contains('hidden') : false;

        // Skip the standby blank row
        var allSt = !icons.length || icons.every(function(x){ return x === 'st'; });
        if(!q && !note && allSt) return;

        rows.push({type:type, q:q, note:note, icons:icons, noteOpen:noteOpen});
      });
      return rows;
    }

    function buildSessionJson_(){
      var meta = {
        forMode: getForMode_(),
        targetName: getTargetName_(),
        godName: getGodName_()
      };
      return JSON.stringify({meta: meta, rows: collectRowsState_()});
    }

    function loadRowsFromSession_(sessionJson){
      var s = String(sessionJson||'').trim();
      if(!s) return;
      var data = null;
      try{ data = JSON.parse(s); }catch(_e){ data = null; }
      if(!data || !Array.isArray(data.rows)) return;

      if(rowsHost) rowsHost.innerHTML = '';
      data.rows.forEach(function(r, idx){
        var type = (r && r.type === 'C') ? 'C' : 'Q';
        var row = makeRow_(idx+1, type);
        setRowType_(row, type);

        var qInp = qs('.dcrQ', row);
        if(qInp) qInp.value = String(r.q || '');

        var nInp = qs('.dcrNote', row);
        if(nInp) nInp.value = String(r.note || '');

        var nr = qs('.dcrNoteRow', row);
        if(nr){
          if(r && r.noteOpen) nr.classList.remove('hidden');
          else nr.classList.add('hidden');
        }

        var iconBtns = qsa('.dcrIconBtn', row);
        var arr = (r && Array.isArray(r.icons)) ? r.icons : [];
        for(var i=0;i<iconBtns.length;i++){
          setIconState_(iconBtns[i], String((arr[i] != null ? arr[i] : 'st')));
        }

        rowsHost.appendChild(row);
      });
      ensureStandbyRow_(rowsHost);
    }

    // Records UI
    var recSearch = qs('#slbDcrSearch', root);
    var recList = qs('#slbDcrList', root);
    if(recList){ recList.innerHTML = '<div style=\"padding:12px;\" class=\"muted small\">Loading records...</div>'; }
    var recViewer = qs('#slbDcrViewer', root);

    var recState = { items: [], selectedId: '', editingId: '', _autoOpened: false };

    function snipText_(s, max){
      s = String(s||'').replace(/\s+/g,' ').trim();
      if(!s) return '';
      if(max && s.length > max) return s.slice(0, max) + '…';
      return s;
    }
    function getEid_(it){
      it = it || {};
      return String(it.entryId || it.entryID || it.id || '').trim();
    }


    // Init viewer shell
    renderViewer_(null);

    // Deep link support (Phase 4)
    function syncRoute_(){
      try{ if(window.SLB_route && window.SLB_route.sync) window.SLB_route.sync(true); }catch(_e){}
    }

    function dcrGetRouteParams_(){
      try{
        if(!recState || !recState.selectedId) return '';
        var sp = new URLSearchParams();
        sp.set('entryId', String(recState.selectedId||''));
        return sp.toString();
      }catch(_e){ return ''; }
    }

    async function dcrOnRoute_(ctx){
      try{
        var sp = (ctx && ctx.params) ? ctx.params : null;
        if(!sp){
          try{ sp = new URLSearchParams(String((ctx && ctx.raw) || '')); }catch(_e2){ sp = null; }
        }
        if(!sp) return;
        var eid = String(sp.get('entryId') || '').trim();
        if(!eid) return;
        await selectRecord_(eid);
      }catch(_e){}
    }

    try{
      if(window.SLB && window.SLB.features && typeof window.SLB.features.register === 'function'){
        window.SLB.features.register('dcr', {
          getRouteParams: function(){ return dcrGetRouteParams_(); },
          onRoute: function(ctx){ dcrOnRoute_(ctx); }
        });
      }
    }catch(_e){}

    function renderList_(){
      if(!recList) return;
      var q = String((recSearch && recSearch.value) || '').trim().toLowerCase();
      var items = (recState.items || []).slice();

      if(q){
        items = items.filter(function(it){
          var dk = fmtDateKey_(it.dateKey || it.updatedAt || it.createdAt || '');
          var hay = (dk + ' ' + (it.targetName||'') + ' ' + (it.godName||'') + ' ' + (it.forMode||'') + ' ' + (it.tag||'')).toLowerCase();
          return hay.indexOf(q) >= 0;
        });
      }

      var h = '';
      h += '<div class="slbDcrListHead">DCR Records</div>';

      if(!items.length){
        h += '<div style="padding:12px; font-weight:800;" class="muted small">No records yet.</div>';
        recList.innerHTML = h;
        return;
      }

      items.forEach(function(it){
        var eid = getEid_(it);
        if(!eid) return;
        var dk = fmtDateKey_(it.dateKey || it.updatedAt || it.createdAt || '');
        var age = timeAgo_(it.updatedAt || it.createdAt || '');
        var tag = snipText_(String((it.tag||'')||'').trim(), 80);
        var active = (recState.selectedId && recState.selectedId === eid) ? ' active' : '';
        h += '<button type="button" class="slbDcrItem'+active+'" data-eid="'+esc(eid)+'">'
          + '<div class="slbDcrItemTop"><div class="slbDcrItemDate">'+esc(dk||'—')+'</div><div class="slbDcrItemAge">'+esc(age)+'</div></div>'
          + '<div class="slbDcrItemTag">'+esc(tag||'')+'</div>'
          + '</button>';
      });

      recList.innerHTML = h;

      qsa('.slbDcrItem', recList).forEach(function(btn){
        btn.addEventListener('click', function(){
          var eid = String(btn.getAttribute('data-eid') || '').trim();
          if(eid) selectRecord_(eid);
        });
      });
    }

    function bindRecViewerBtns_(item){
      var bR = qs('#slbDcrVRefresh', recViewer);
      if(bR){
        bR.addEventListener('click', async function(){
          var eid = String(recState.selectedId||'').trim();
          recState.items = [];
          await refreshList_(0, true);
          if(eid) await selectRecord_(eid);
        });
      }

      var bE = qs('#slbDcrVEdit', recViewer);
      if(bE && item){
        bE.addEventListener('click', function(){
          try{
            // open top section
            var d1 = qs('#slbDcrPanel details.slbDcrDetails');
            if(d1) d1.open = true;
          }catch(_e){}
          try{ loadToEditor_(item); }catch(_e2){}
          try{ var top = qs('#slbDcrPanel'); if(top) top.scrollIntoView({behavior:'smooth', block:'start'}); }catch(_e3){}
        });
      }

      var bD = qs('#slbDcrVDel', recViewer);
      if(bD && item){
        bD.addEventListener('click', function(){
          try{ deleteRecord_(item); }catch(_e){}
        });
      }
    }

    function renderViewer_(it){
      if(!recViewer) return;

      if(!it){
        recViewer.innerHTML = ''
          + '<div class="slbDcrViewerHead">'
          +   '<div class="slbDcrViewerTitle">DCR Entry</div>'
          +   '<div class="slbDcrViewerBtns">'
          +     '<button type="button" class="btn btnWhite" id="slbDcrVRefresh">REFRESH</button>'
          +   '</div>'
          + '</div>'
          + '<div class="slbDcrViewerBody"><div class="slbDcrSmall">Select a record on the left.</div></div>';
        bindRecViewerBtns_(null);
        return;
      }

      // loading shell
      if(it && it.__loading){
        recViewer.innerHTML = ''
          + '<div class="slbDcrViewerHead">'
          +   '<div class="slbDcrViewerTitle">Loading…</div>'
          +   '<div class="slbDcrViewerBtns"></div>'
          + '</div>'
          + '<div class="slbDcrViewerBody"><div class="slbDcrSmall">Loading entry…</div></div>';
        return;
      }

      var dk = fmtDateKey_(it.dateKey || it.updatedAt || it.createdAt || '');
      var age = timeAgo_(it.updatedAt || it.createdAt || '');
      var meta = 'Updated: ' + esc(it.updatedAt||it.createdAt||'') + (age ? (' ('+esc(age)+')') : '');

      var parts = [];
      if(it.forMode){
        var fm = String(it.forMode||'').trim().toLowerCase();
        parts.push('For: ' + esc((fm === 'myself' || fm === 'me') ? 'Myself' : 'Others'));
      }
      if(it.targetName) parts.push('Name: ' + esc(it.targetName));
      if(it.godName) parts.push('God: ' + esc(it.godName));
      if(parts.length) meta += '<br>' + parts.join(' &nbsp;|&nbsp; ');

      var bodyHtml = it.bodyRich ? String(it.bodyRich) : (it.body ? nl2br(it.body) : '');

      var html = '';
      html += '<div class="slbDcrViewerHead">'
        + '<div class="slbDcrViewerTitle">'+esc(dk||'DCR Entry')+'</div>'
        + '<div class="slbDcrViewerBtns">'
        +   '<button type="button" class="btn btnWhite" id="slbDcrVRefresh">REFRESH</button>'
        +   '<button type="button" class="btn primary" id="slbDcrVEdit">EDIT</button>'
        +   '<button type="button" class="btn danger" id="slbDcrVDel">DELETE</button>'
        + '</div>'
        + '</div>';

      html += '<div class="slbDcrViewerBody">'
        + '<div class="slbDcrMeta">'+meta+'</div>'
        + '<div class="slbDcrCard"><h4>Report</h4><div class="content">'+(bodyHtml||'')+'</div></div>'
        + '</div>';

      recViewer.innerHTML = html;
      bindRecViewerBtns_(it);
    }


    async function refreshList_(_tries, _silent){
      _tries = _tries || 0;
      _silent = (_silent !== false);
      if(!getRpc_()){
        if(!_silent && _tries === 0) toast('Backend not ready.');
        if(_tries < 40){
          setTimeout(function(){ refreshList_(_tries+1, true); }, 250);
        }
        return;
      }

      try{
        var res = await rpcData_('dcrList', {limit: 250});
        recState.items = (res && res.items) ? res.items : [];
        renderList_();

        if(!recState._autoOpened && !recState.selectedId && recState.items && recState.items.length){
          recState._autoOpened = true;
          selectRecord_(getEid_(recState.items[0]));
        }

        if(recState.selectedId){
          var ok = recState.items.some(function(x){ return getEid_(x) === recState.selectedId; });
          if(!ok){
            recState.selectedId = '';
            renderViewer_(null);
          }
        }
        }catch(e){
        console.error(e);
        if(recList){ recList.innerHTML = '<div style="padding:12px; font-weight:800;" class="muted small">Failed to load records.</div>'; }
        toast('Failed to load records.');
      }finally{
      }
    }

    async function selectRecord_(entryId){
      entryId = String(entryId||'').trim();
      if(!entryId) return;

      if(!getRpc_()){ toast('Backend not ready.'); return; }

      recState.selectedId = entryId;
      renderList_();
      renderViewer_({__loading:true});

      var item = null;
      try{
        var out = await rpcData_('dcrGet', { entryId: entryId, includeRich: true, includeSession: true });
        item = (out && (out.item || out.entry || out.data)) ? (out.item || out.entry || out.data) : null;
      }catch(e){
        item = null;
      }

      if(!item){
        if(recViewer){
          recViewer.innerHTML = ''
            + '<div class="slbDcrViewerHead">'
            +   '<div class="slbDcrViewerTitle">DCR Entry</div>'
            +   '<div class="slbDcrViewerBtns"><button type="button" class="btn btnWhite" id="slbDcrVRefresh">REFRESH</button></div>'
            + '</div>'
            + '<div class="slbDcrViewerBody"><div class="slbDcrSmall">Failed to load.</div></div>';
          bindRecViewerBtns_(null);
        }
        return;
      }

      renderViewer_(item);
      syncRoute_();
    }


    function loadToEditor_(it){
      if(!it) return;
      recState.editingId = it.entryId || '';

      setMetaUi_(it);
      loadRowsFromSession_(it.sessionJson || '');

      if(tagInp) tagInp.value = String((it.tag||'')||'');

      if(finalRich) finalRich.innerHTML = it.bodyRich || '';

      if(bSave) bSave.disabled = false;
      if(bEmailJee) bEmailJee.disabled = false;

      toast('Loaded. Edit and Save to overwrite.');
      try{ if(edRoot) edRoot.scrollIntoView({behavior:'smooth', block:'start'}); }catch(_e){}
    }

    async function deleteRecord_(it){
      if(!it || !it.entryId) return;
      if(!confirm('Delete this record?')) return;
      if(!getRpc_()){ toast('Backend not ready.'); return; }

      try{
        await rpcData_('dcrDelete', {entryId: it.entryId});
        toast('Deleted.');

        if(recState.selectedId === it.entryId){
          recState.selectedId = '';
          renderViewer_(null);
        }
        if(recState.editingId === it.entryId){
          recState.editingId = '';
          resetAll_();
        }
        await refreshList_();
      }catch(e){
        console.error(e);
        toast('Delete failed.');
      }
    }

    if(recSearch) recSearch.addEventListener('input', function(){ renderList_(); });

    if(bSave){
      bSave.addEventListener('click', async function(){
        if(!getRpc_()){ toast('Backend not ready.'); return; }

        var plain = String(finalRich ? finalRich.innerText : '').trim();
        if(!plain){ toast('Finalize first.'); return; }

        var html = String(finalRich ? finalRich.innerHTML : '').trim();

        var payload = {
          entryId: recState.editingId || '',
          dateKey: dateKeyNow_(),
          forMode: getForMode_(),
          targetName: getTargetName_(),
          godName: getGodName_(),
          tag: String(tagInp ? tagInp.value : '').trim(),
          sessionJson: buildSessionJson_(),
          body: plain,
          bodyRich: html,
          notes: '',
          notesRich: ''
        };

        bSave.disabled = true;
        try{
          var res = await rpcData_('dcrUpsert', payload);
          recState.editingId = (res && res.entryId) ? res.entryId : (recState.editingId || '');
          toast('Saved.');
          await refreshList_();
        }catch(e){
          console.error(e);
          toast('Save failed.');
        }finally{
          bSave.disabled = false;
        }
      });
    }

    if(bEmailJee){
      bEmailJee.addEventListener('click', async function(){
        if(!getRpc_()){ toast('Backend not ready.'); return; }

        var plain = String(finalRich ? finalRich.innerText : '').trim();
        if(!plain){ toast('Finalize first.'); return; }

        var html = String(finalRich ? finalRich.innerHTML : '').trim();

        bEmailJee.disabled = true;
        try{
          await rpcData_('dcrEmailJee', {
            dateKey: dateKeyNow_(),
            reportText: plain,
            reportHtml: html,
            meta: {
              forMode: getForMode_(),
              targetName: getTargetName_(),
              godName: getGodName_(),
              tag: String(tagInp ? tagInp.value : '').trim()
            }
          });
          toast('Sent.');
        }catch(e){
          console.error(e);
          toast('Email failed.');
        }finally{
          bEmailJee.disabled = false;
        }
      });
    }

    if(recList) refreshList_(0, true);

    // V4.9: auto-clear on the actual DCR panel visibility transition instead of
    // waking every 700ms for the rest of the SLB session.
    var wasOpen = false;
    function dcrCheckOpenState_(){
      try{
        var hall = root.closest ? root.closest('#slbBagwaHallPanel') : null;
        var inPreloadDock = !!(root.parentElement && root.parentElement.id === 'slbBagwaPreloadDock');
        var isOpen = !root.classList.contains('hidden') && !root.hidden && !inPreloadDock && !(hall && hall.classList.contains('hidden'));
        if(isOpen && !wasOpen){
          // If opened via deep link (entryId), don't auto-clear.
          var h = String(location.hash||'');
          var hl=h.toLowerCase();var hasEntry = (h.indexOf('entryId=') >= 0 && (hl.indexOf('#dcr') === 0 || (hl.indexOf('tab=bagwahall') >= 0 && hl.indexOf('bagwa=dcr') >= 0)));
          if(!hasEntry) resetAll_();
        }
        wasOpen = isOpen;
      }catch(_e){}
    }
    dcrCheckOpenState_();
    try{
      if(window.MutationObserver){
        var dcrOpenObserver_ = new MutationObserver(dcrCheckOpenState_);
        dcrOpenObserver_.observe(root,{attributes:true,attributeFilter:['class','hidden']});
      }
    }catch(_eObs){}

    return true;
  }

  // V4.10: shared startup readiness owns DCR boot. The old code woke every
  // 250ms for up to a minute waiting for core/auth. Readiness events do the
  // normal wake-up now; a few bounded one-shots remain only as compatibility
  // insurance for unusual old-browser/script-order cases.
  var dcrBootDone_ = false;
  function dcrBootCleanup_(){
    try{ window.removeEventListener('slb:core-ready', dcrBootWake_); }catch(_e1){}
    try{ window.removeEventListener('slb:rpc-ready', dcrBootWake_); }catch(_e2){}
    try{ window.removeEventListener('slb:auth-ready', dcrBootWake_); }catch(_e3){}
    try{ document.removeEventListener('DOMContentLoaded', dcrBootWake_); }catch(_e4){}
  }
  function dcrBootWake_(){
    if(dcrBootDone_) return true;
    var ok = false;
    try{ ok = bootUser_(); }catch(_e){ ok = false; }
    if(ok){ dcrBootDone_ = true; dcrBootCleanup_(); }
    return ok;
  }
  try{ window.addEventListener('slb:core-ready', dcrBootWake_); }catch(_e5){}
  try{ window.addEventListener('slb:rpc-ready', dcrBootWake_); }catch(_e6){}
  try{ window.addEventListener('slb:auth-ready', dcrBootWake_); }catch(_e7){}
  try{ document.addEventListener('DOMContentLoaded', dcrBootWake_); }catch(_e8){}
  dcrBootWake_();
  setTimeout(dcrBootWake_, 1200);
  setTimeout(dcrBootWake_, 5000);
  setTimeout(dcrBootWake_, 15000);

})();

